import { ref } from 'vue';
import { show, hide, isActive } from './useLoading';

const queue = ref({});

const useFixedBarLoading = () => ({
  queue,
  isActive: isActive(queue),
  show: show(queue),
  hide: hide(queue),
});

export default useFixedBarLoading;
